// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../../../../../types';
import PriceComponent from '../../../../../../price';

type Props = {|
  amount: number,
  active: boolean,
  postfix?: string,
|};

const StyledPrice = styled<typeof PriceComponent, Theme, Props>(PriceComponent)`
  font-size: 0.875rem;
  color: ${props => (
    props.active
      ? 'inherit'
      : props.theme.configColor.price.color
  )};
`;

const Price = ({ amount, ...props }: Props) => (
  <StyledPrice
    amount={amount}
    decimalDash={false}
    displayZeroes={false}
    displayCurrencySymbol={false}
    displayCurrencyText
    displayPrefix
    {...props}
  />
);

Price.defaultProps = {
  postfix: null,
};

export default Price;
